"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityIndexNoneRule = void 0;
exports.hasNoIndex = hasNoIndex;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'entity-index-none';
const ruleName = 'entity without index';
const ruleDescription = 'entities with no primary key and no index (only tables)';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('EntityIndexNoneConf');
exports.entityIndexNoneRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || []).filter(hasNoIndex)
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has no index.`,
            entity: (0, databaseUtils_1.entityToRef)(e),
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/TableWithoutIndex.elm
function hasNoIndex(entity) {
    return (entity.kind === undefined || entity.kind === database_1.EntityKind.enum.table) && entity.pk === undefined && (entity.indexes || []).length === 0;
}
//# sourceMappingURL=entityIndexNone.js.map